import { render, staticRenderFns } from "./previousInfo.vue?vue&type=template&id=16b16d48&scoped=true&"
import script from "./previousInfo.vue?vue&type=script&lang=js&"
export * from "./previousInfo.vue?vue&type=script&lang=js&"
import style0 from "./previousInfo.vue?vue&type=style&index=0&id=16b16d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b16d48",
  null
  
)

export default component.exports